import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("geni_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("geni_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    // Enrich message so toasts show the failing URL — helps diagnose 404s.
    if (err?.response) {
      const { status, config } = err.response;
      const path = config?.url || "?";
      err.message = `${err.message} — ${status} ${path}`;
    }
    return Promise.reject(err);
  }
);

export default api;
